import { useEffect } from 'react';
type StructuredDataProps = {
  /** Identifiant unique du bloc, pour éviter les doublons */
  id: string;
  /** Objet JSON-LD (schema.org) */
  data: Record<string, unknown> | Record<string, unknown>[];
};

/**
 * Injecte des données structurées schema.org dans la page.
 * Permet à Google d'afficher des résultats enrichis
 * (organisme de formation, formations, questions fréquentes).
 */
export function StructuredData({
  id,
  data
}: StructuredDataProps) {
  useEffect(() => {
    const scriptId = `structured-data-${id}`;
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
    return () => {
      document.getElementById(scriptId)?.remove();
    };
  }, [id, data]);
  return null;
}